var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 2.66675H2.66671C2.31309 2.66675 1.97395 2.80722 1.7239 3.05727C1.47385 3.30732 1.33337 3.64646 1.33337 4.00008V13.3334C1.33337 13.687 1.47385 14.0262 1.7239 14.2762C1.97395 14.5263 2.31309 14.6667 2.66671 14.6667H12C12.3537 14.6667 12.6928 14.5263 12.9428 14.2762C13.1929 14.0262 13.3334 13.687 13.3334 13.3334V8.66675",
    stroke: "#1479FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.66666C12.5986 1.40144 12.9583 1.25244 13.3334 1.25244C13.7084 1.25244 14.0682 1.40144 14.3334 1.66666C14.5986 1.93187 14.7476 2.29158 14.7476 2.66666C14.7476 3.04173 14.5986 3.40144 14.3334 3.66666L8.00004 9.99999L5.33337 10.6667L6.00004 7.99999L12.3334 1.66666Z",
    stroke: "#1479FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.970c3cfc2bba3bc5882df83780d0277a.svg";
export { ForwardRef as ReactComponent };